(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-card-rolodex"] && !Shopify.designMode) return;
  try {
    
class NMRolodex extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.nm-rolodex__card'));
    if (!this.cards.length) return;
    this.active = 0;
    this.titleEl = this.querySelector('.nm-rolodex__title');
    this.priceEl = this.querySelector('.nm-rolodex__price');
    this.querySelector('.nm-rolodex__nav--prev').addEventListener('click', () => this.step(-1));
    this.querySelector('.nm-rolodex__nav--next').addEventListener('click', () => this.step(1));
    this.cards.forEach((card, i) => {
      card.addEventListener('click', (e) => {
        if (i !== this.active) {
          e.preventDefault();
          this.setActive(i);
        }
      });
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.step(-1);
      if (e.key === 'ArrowRight') this.step(1);
    });
    this.setActive(0);
  }

  step(dir) {
    const n = this.cards.length;
    this.setActive((this.active + dir + n) % n);
  }

  setActive(index) {
    this.active = index;
    const n = this.cards.length;
    this.cards.forEach((card, i) => {
      let offset = i - index;
      if (offset > n / 2) offset -= n;
      if (offset < -n / 2) offset += n;
      const abs = Math.abs(offset);
      const visible = abs <= 2;
      const x = offset * 46;
      const rotate = offset * -28;
      const z = -abs * 130;
      const scale = 1 - abs * 0.07;
      card.style.transform =
        'translateX(' + x + '%) translateZ(' + z + 'px) rotateY(' + rotate + 'deg) scale(' + scale + ')';
      card.style.opacity = visible ? String(1 - abs * 0.25) : '0';
      card.style.zIndex = String(100 - abs);
      card.style.pointerEvents = visible ? 'auto' : 'none';
      card.classList.toggle('is-active', i === index);
      card.setAttribute('tabindex', i === index ? '0' : '-1');
      card.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
    const activeCard = this.cards[index];
    if (this.titleEl) this.titleEl.textContent = activeCard.dataset.title || '';
    if (this.priceEl) {
      this.priceEl.textContent = activeCard.dataset.soldout
        ? (activeCard.dataset.price || '') + ' — Sold out'
        : activeCard.dataset.price || '';
    }
  }
}

customElements.define('nm-rolodex', NMRolodex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-browse"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-np-price]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  url.searchParams.delete('filter.v.price.gte');
  url.searchParams.delete('filter.v.price.lte');
  if (link.dataset.npPrice === 'budget') url.searchParams.set('filter.v.price.lte', '4.99');
  event.preventDefault();
  window.location.assign(url.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-bulk"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('np-bulk')) {
  customElements.define('np-bulk', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.querySelector('[data-quantity]')) return;
      this.ready = true;
      this.inputs = [...this.querySelectorAll('[data-quantity]')];
      this.other = this.querySelector('[data-other]');
      this.money = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'});
      this.querySelector('.np-bulk__tabs').hidden = false;
      this.showGame('Pokemon');
      this.querySelectorAll('[data-game]').forEach(button => button.addEventListener('click', () => this.showGame(button.dataset.game)));
      this.inputs.forEach(input => input.addEventListener('input', () => {
        if (/^\d+$/.test(input.value)) input.value = String(Number(input.value));
        this.recalculate();
      }));
      this.other.addEventListener('change', () => this.recalculate());
      this.querySelector('form').addEventListener('submit', event => {
        if (this.dataset.dashboard === 'true') event.preventDefault();
        const result = this.recalculate();
        if (!result.valid || (!result.count && !this.other.checked)) {
          event.preventDefault();
          const error = this.querySelector('[data-quantity-error]');
          error.textContent = !result.valid ? this.dataset.invalid : this.dataset.required;
          error.hidden = false;
          const invalid = this.inputs.find(input => !input.validity.valid) || this.inputs[0];
          this.showGame(invalid.closest('[data-group]').dataset.group);
          invalid.focus();
          invalid.reportValidity();
          return;
        }
        if (this.dataset.dashboard === 'true') this.submitWorkflow();
      });
      this.querySelector('form').addEventListener('invalid', event => {
        const group = event.target.closest('[data-group]');
        if (group) this.showGame(group.dataset.group);
      }, true);
      this.recalculate();
      if (this.dataset.dashboard === 'true') this.setupWorkflow();
    }
    async setupWorkflow() {
      this.workflowMessage = this.querySelector('[data-workflow-message]');
      this.workflowButton = this.querySelector('button[type=submit]');
      try {
        if (!this.dataset.sitekey) throw new Error('Submissions are being set up. Please contact Nearly Played TCG.');
        if (!window.npTurnstileReady) window.npTurnstileReady = new Promise((resolve, reject) => {
          if (window.turnstile) return resolve();
          const script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true; script.onload = resolve; script.onerror = reject;
          document.head.append(script);
        });
        await window.npTurnstileReady;
        this.widget = window.turnstile.render(this.querySelector('[data-verification]'), {sitekey: this.dataset.sitekey, action: 'bulk-submit'});
        this.workflowButton.disabled = false;
      } catch { this.workflowMessage.textContent = 'Unable to load submission verification. Please reload or contact Nearly Played TCG.'; }
    }
    async submitWorkflow() {
      if (this.sending || !this.workflowButton) return;
      const form = this.querySelector('form'), fields = new FormData(form);
      const get = key => String(fields.get(key) || '');
      const token = window.turnstile?.getResponse(this.widget);
      if (!token) { this.workflowMessage.textContent = 'Please complete the verification before submitting.'; this.workflowMessage.focus(); return; }
      const payload = {seller_name:get('contact[name]'), seller_email:get('contact[email]'), paypal_email:get('contact[PayPal email]'),
        condition:get('contact[Condition]'), description:get('contact[body]'), location:get('contact[City and region]'),
        photo_url:get('contact[Photo link]'), timeline:get('contact[Timeline]'), seller_notes:get('contact[Additional notes]'),
        consent:fields.get('contact[Ownership and review consent]') === 'Confirmed', collection_review:this.other.checked,
        lines:this.inputs.filter(input=>Number(input.value)>0).map(input=>({category:input.dataset.title,quantity:Number(input.value),rate_cents:Number(input.dataset.rate),unit:Number(input.dataset.unit)}))};
      const fingerprint = JSON.stringify(payload);
      if (this.lastSubmission !== fingerprint) { this.requestKey = crypto.randomUUID(); this.lastSubmission = fingerprint; }
      this.sending = true; this.workflowButton.disabled = true; this.workflowMessage.textContent = 'Submitting your cards for review…';
      try {
        const response = await fetch('/apps/nearly-played-bulk', {method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({...payload,request_key:this.requestKey,website:get('website'),turnstile_token:token}), signal:AbortSignal.timeout(25000)});
        const result = await response.json();
        if (!response.ok || typeof result.reference !== 'string') throw new Error(result.error || 'Unable to confirm your submission. Please try again.');
        const success = document.createElement('div'); success.className = 'np-bulk__success'; success.tabIndex = -1; success.setAttribute('role','status');
        const heading = document.createElement('h2'); heading.textContent = 'Your submission is in for review.';
        const detail = document.createElement('p'); detail.textContent = `Reference: ${result.reference}. Keep this reference. Ram will review your cards and email the next steps. Please wait for approval before shipping.`;
        success.append(heading,detail); form.replaceChildren(success); success.focus();
      } catch (error) {
        this.workflowMessage.textContent = (error.name === 'TimeoutError' ? 'We could not confirm receipt. Your details are still here; retry to check the same submission.' : error.message || 'Unable to confirm receipt. Please try again.');
        this.workflowMessage.focus(); this.workflowButton.disabled = false;
        window.turnstile?.reset(this.widget);
      } finally { this.sending = false; }
    }
    showGame(game) {
      this.querySelectorAll('[data-group]').forEach(group => group.hidden = group.dataset.group !== game);
      this.querySelectorAll('[data-game]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.game === game)));
    }
    recalculate() {
      let cents = 0, count = 0, valid = true;
      const snapshot = [];
      const lines = this.querySelector('[data-lines]');
      lines.replaceChildren();
      this.inputs.forEach(input => {
        const quantity = input.value === '' ? 0 : Number(input.value);
        const rate = Number(input.dataset.rate), unit = Number(input.dataset.unit);
        const acceptable = (input.value === '' || /^\d+$/.test(input.value)) && Number.isSafeInteger(quantity) && quantity >= 0 && quantity <= 1000000;
        const rateOK = Number.isSafeInteger(rate) && rate >= 0 && [1,1000].includes(unit);
        input.setCustomValidity(!acceptable ? this.dataset.invalid : !rateOK ? this.dataset.rateError : '');
        input.setAttribute('aria-invalid', String(!acceptable || !rateOK));
        if (!acceptable || !rateOK) { valid = false; return; }
        if (!quantity) return;
        const lineCents = Math.round(quantity * rate / unit);
        count += quantity; cents += lineCents;
        const row = `${input.dataset.title}: ${quantity.toLocaleString('en-US')} × ${this.money.format(rate / 100)} per ${unit} = ${this.money.format(lineCents / 100)}`;
        snapshot.push(row);
        const li = document.createElement('li'); li.textContent = row; lines.append(li);
      });
      if (!snapshot.length) { const li = document.createElement('li'); li.textContent = this.dataset.empty; lines.append(li); }
      this.querySelector('[data-total]').textContent = valid ? this.money.format(cents / 100) : '—';
      this.querySelector('[data-count]').textContent = count.toLocaleString('en-US');
      this.querySelector('[data-manual]').hidden = !this.other.checked;
      this.querySelector('[data-estimate-field]').value = valid ? `${this.money.format(cents / 100)} USD (estimate only)` : 'Manual review required';
      this.querySelector('[data-snapshot]').value = [...snapshot, `Total cards: ${count}`, `Other collection: ${this.other.checked ? 'Yes — quote separately' : 'No'}`, 'Client-calculated estimate only; verify rates, quantities, eligibility and condition before approval.'].join('\n');
      const error = this.querySelector('[data-quantity-error]');
      error.hidden = valid;
      if (!valid) error.textContent = this.dataset.invalid;
      return {valid, count};
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
